/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Blocklist_DescriptionInputs */

const en_carrier_blocklist_description = /** @type {(inputs: Carrier_Blocklist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle carriers to block or allow for this user`)
};

const es_carrier_blocklist_description = /** @type {(inputs: Carrier_Blocklist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activa o bloquea transportistas para este usuario`)
};

/**
* | output |
* | --- |
* | "Toggle carriers to block or allow for this user" |
*
* @param {Carrier_Blocklist_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_blocklist_description = /** @type {((inputs?: Carrier_Blocklist_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Blocklist_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_blocklist_description(inputs)
	return es_carrier_blocklist_description(inputs)
});